import { Cart } from "../../types/api/Cart";
import { Undefinable } from "../../utils/Nullable";

export function lineItemTotal(cart: Undefinable<Cart>) {
  if (!cart) {
    return 0;
  }
  return cart?.line_items
    .map((lineItem) => lineItem.quantity * lineItem.product.unit_price_in_cents)
    .reduce((acc, lineItem) => acc + lineItem, 0);
}

export function lineItemQuantity(cart: Undefinable<Cart>) {
  if (!cart) {
    return 0;
  }
  return (
    cart?.line_items
      .map((li) => li.quantity)
      .reduce((acc, li) => acc + li, 0) || 0
  );
}
